import React from "react";

export const LoadingButton = ({
  type,
  isLoading,
  onClick,
  disabled,
  buttonText,
  loadingText,
  className = "",
}) => {
  return (
    <button
      type={type} 
      onClick={onClick}
      disabled={disabled || isLoading}
      className={`p-3 px-9 text-white rounded-[10px] ${className} ${
        isLoading || disabled ? "opacity-50 cursor-not-allowed" : ""
      }`}
    >
      {isLoading ? (
        <span className="flex justify-center">
          <svg
            className="animate-spin h-5 w-5 mr-3"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
            />
          </svg>
          {loadingText}
        </span>
      ) : (
        buttonText
      )}
    </button>
  );
};
